<div
  class="ops-fiscal-year-component"
  [class.is-preview]="isPreview || isForcedPreview"
  [class.expanded]="isExpanded === 1"
  [class.collapsed]="isExpanded === 2"
>
  <div *ngIf="isPreview || isForcedPreview" class="sort-button preview-btn">
    <span>{{ selectedYearValue }}</span>
  </div>
  <button
    *ngIf="!isPreview && !isForcedPreview"
    type="button"
    class="sort-button"
    [disabled]="isForcedPreview"
    [class.preview-btn]="isForcedPreview"
    (click)="isForcedPreview ? null : toggleSort()"
  >
    <span> {{ selectedYearValue }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M19.833 16.333L13.9997 11.6663L8.16634 16.333"
        stroke="#3B3B3B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
  

  <div class="sort-options-wrapper">
    <div class="sort-options-container">
      <div
        *ngFor="let yearItem of _fiscalYearList"
        class="sort-option-item"
        (click)="selectOption(yearItem._id)"
      >
        <span>{{ 'fiscalYear.fy' | translate }} {{ yearItem?.yearNumber }}</span>
      </div>
    </div>
  </div>
</div>
